import { LinkShortcutsProps } from "@made-people/blueprint-link-shortcuts";

/**
 * In this file you can specify default props for components that render,
 * which have been wrapped with withManagedProps
 */

export const LinkShortcuts: LinkShortcutsProps = {
  layout: {
    position: {
      maxWidth: "xl",
    },
  },
  features: {
    linkVariants: {
      size: "md",
      style: "solid",
      color: "black",
      rounded: "full",
    },
  },
  useScrollWrapper: true,
};
